import App from '../../components/App';
import props from '../../configs/propsGlitch';

export default function FontGenerator() {
  return <App {...props} />;
}
